import React, { useEffect, useState } from 'react';
import axios, { AxiosResponse } from 'axios';
import { Link } from 'react-router-dom';
import Api from 'constants/constants';

import s from './Footer.module.scss';

const Footer = () => {
  const [footerText, setFooterText] = useState('');

  useEffect(() => {
    axios.get(Api.FOOTER)
      .then((res: AxiosResponse<string>) => {
        if (res) setFooterText(res.data);
      })
      .catch();
  }, []);

  return (
    <footer className={s.Footer}>
      <div className="container">
        <div className={s.LinksWrapper}>
          <Link className={s.Link} to="/user/conditions">Пользовательское соглашение</Link>
          <Link className={s.Link} to="/privacypolicy">Политика обработки персональных данных</Link>
        </div>
        <div dangerouslySetInnerHTML={{ __html: footerText }} />
      </div>
    </footer>
  );
};

export default Footer;
